import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Card, Col, DatePicker, Empty, Form, Input, Pagination, Row, Select, Table } from 'antd';
import moment from 'moment';
import { ColumnProps } from 'antd/lib/table';
import { ProductService } from '@gtpl/shared-services/masters';
import ExcelJs from 'exceljs'
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { CollectionsService, PurchasesProductService } from '@gtpl/shared-services/finance';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
const InvoiceInfoReport = () => {
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const saleOrderService = new SaleOrderService();
  const [filterForm] = Form.useForm()
  const [variants, setVariants] = useState<any[]>([])
  const variantService = new ProductService()
  const [poNumbers, setPoNumbers] = useState<any[]>([]);
  const saleService = new SaleOrderService();
  const collectionsService = new CollectionsService()
  const [invoiceNumber, setInvoiceNumber] = useState([])
    const [poDropDown, setPoDropDown] = useState<any[]>([]);
       const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<any>(null);

  const { Option } = Select

  const handleExportExcel = async () => {
    if (!data || data.length === 0) {
      return;
    }

    const workbook = new ExcelJs.Workbook();
    const worksheet = workbook.addWorksheet('Invoice Info Report');

    const headerRow = [
      'S No',
      'Invoice Date',
      'Invoice Number',
      'Cust PO No',
      'Client Name',
      'End Customer Name',
      'Country',
      'Destination',
      'Currency',
      'Total Amount',
      'Exchange Rate',
      'Total INR Amount',
      'Status',
      'Financial Year',
      'Q Cert No',
      'Pack Style',
      'Short Code',
      'Net Weight',
      'Unit Price',
      'Net Amount',
      'Invoiced Cases'
    ];

    worksheet.addRow(headerRow);

    let excelRowIndex = 2;
    let excelTotalAmount = 0;
    let excelTotalInrAmount = 0;
    let excelNetWeight = 0;
    let excelNetAmount = 0;
    let excelInvoicedCases = 0;
    let serialNo = 1;
    const exportInvoices = data;
    exportInvoices.forEach((invoice: any) => {
      excelTotalAmount += Number(invoice.totalAmount || 0);
      excelTotalInrAmount += Number(invoice.totalInrAmount || 0);

      const items = invoice.saleOrderItemsDetails && invoice.saleOrderItemsDetails.length > 0 ? invoice.saleOrderItemsDetails : [{}];
      const invoiceRowSpan = items.length;

      items.forEach((item: any, itemIndex: number) => {
        const isFirstItem = itemIndex === 0;

        excelNetWeight += Number(item.netWeight || 0);
        excelNetAmount += Number(item.netAmount || 0);
        excelInvoicedCases += Number(item.invoicedCases || 0);

        const rowValues = [
          isFirstItem ? (serialNo || '-') : '',
          isFirstItem ? (invoice.invoiceDate ? moment(invoice.invoiceDate).format('DD-MM-YYYY') : '-') : '',
          isFirstItem ? (invoice.invoiceNumber || '-') : '',
          isFirstItem ? (invoice.custPoNo || '-') : '',
          isFirstItem ? (invoice.clientName || '-') : '',
          isFirstItem ? (invoice.endCustomerName || '-') : '',
          isFirstItem ? (invoice.country || '-') : '',
          isFirstItem ? (invoice.destinationName || '-') : '',
          isFirstItem ? (invoice.currency || '-') : '',
          isFirstItem ? (invoice.totalAmount ? Number(Number(invoice.totalAmount).toFixed(2)) : '-') : '',
          isFirstItem ? (invoice.exchangeRate ? Number(Number(invoice.exchangeRate).toFixed(2)) : '-') : '',
          isFirstItem ? (invoice.totalInrAmount ? Number(Number(invoice.totalInrAmount).toFixed(2)) : '-') : '',
          isFirstItem ? (invoice.status || '-') : '',
          isFirstItem ? (invoice.financialYear || '-') : '',
          isFirstItem ? (invoice.qCertificateNo || '-') : '',
          isFirstItem ? (invoice.packStyle || '-') : '',
          item.shortCode || '-',
          item.netWeight ? Number(Number(item.netWeight).toFixed(2)) : '-',
          item.unitPrice ? Number(Number(item.unitPrice).toFixed(2)) : '-',
          item.netAmount ? Number(Number(item.netAmount).toFixed(2)) : '-',
          item.invoicedCases ? Number(Number(item.invoicedCases).toFixed(2)) : '-'
        ];

        worksheet.addRow(rowValues);
        excelRowIndex += 1;
      });

      if (invoiceRowSpan > 1) {
        const startRow = excelRowIndex - invoiceRowSpan;
        const endRow = excelRowIndex - 1;
        for (let col = 1; col <= 16; col += 1) {
          worksheet.mergeCells(startRow, col, endRow, col);
        }
      }
      serialNo += 1;
    });

    worksheet.addRow([
      'Total', '', '', '', '', '', '', '', '',
      excelTotalAmount ? Number(Number(excelTotalAmount).toFixed(2)) : '-',
      '',
      excelTotalInrAmount ? Number(Number(excelTotalInrAmount).toFixed(2)) : '-',
      '', '', '', '', '',
      excelNetWeight ? Number(Number(excelNetWeight).toFixed(2)) : '-',
      '',
      excelNetAmount ? Number(Number(excelNetAmount).toFixed(2)) : '-',
      excelInvoicedCases ? Number(Number(excelInvoicedCases).toFixed(2)) : '-'
    ]);

    worksheet.mergeCells(`A${excelRowIndex}:I${excelRowIndex}`);
    worksheet.getRow(excelRowIndex).font = { bold: true };
    excelRowIndex += 1;

    headerRow.forEach((_, index) => {
      const column = worksheet.getColumn(index + 1);
      column.width = 15;
    });

    const header = worksheet.getRow(1);
    header.font = { bold: true };
    header.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF92D050' },
      };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Invoice_Info_Report.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const getInvoiceReportData = () => {
    const req: any = {};
    if (filterForm.getFieldValue('poNumber')) {
      req.poNumber = filterForm.getFieldValue('poNumber')
    }

    if (filterForm.getFieldValue('invoiceNum')) {
      req.invoiceNum = filterForm.getFieldValue('invoiceNum')
    }

    if (filterForm.getFieldValue('invoiceDate') && filterForm.getFieldValue('invoiceDate')[0]) {
      req.fromDate = (filterForm.getFieldValue('invoiceDate')[0]).format('YYYY-MM-DD');
      req.toDate = (filterForm.getFieldValue('invoiceDate')[1]).format('YYYY-MM-DD');
    }
    saleOrderService.getInvoiceReportData(req).then((res: any) => {
      if (res?.status) {
        setData(res.data || []);
      } else {
        setData([]);
      }
    });
  };

  useEffect(() => {
    getInvoiceReportData();
    getVariants();
    getAllInvoiceNumbers()
    getAllPoNumbers();
    getDistinctPoNumbers()
  }, []);

  useEffect(() => {
    const maxPage = Math.max(1, Math.ceil((data?.length || 0) / pageSize));
    if (page > maxPage) setPage(1);
  }, [data?.length, pageSize]);

  function handleSearch(selectedKeys: any, confirm: any, dataIndex: any) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  }

  function handleReset(clearFilters: any) {
    clearFilters();
    setSearchText("");
  }

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() =>
            handleSearch(selectedKeys, confirm, dataIndex)
          }
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered: any) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value: any, record: any) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    render: (text: any) =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        )
      ) : null,
  });

  const getVariants = () => {
    variantService.getAllActiveProducts().then(res => {
      if (res.status) {
        setVariants(res.data)
      } else {
        setVariants([])
      }
    })
  }

  const getAllInvoiceNumbers = (req?: any) => {
    collectionsService.getAllInvoiceNumber().then((res) => {
      if (res.status) {
        setInvoiceNumber(res.data)
      }
      else {
        setInvoiceNumber([])
      }
    })
  }

  const getAllPoNumbers = () => {
    saleService.getPoNumbers().then((res) => {
      if (res.status) {
        setPoNumbers(res.data);
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
        setPoNumbers([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setPoNumbers([]);
    });
  }

    const getDistinctPoNumbers = () => {
    saleService.getDistinctPoNumbers({ unitId: Number(localStorage.getItem('unit_id')) })
      .then((res) => {
        if (res.status) {
          setPoDropDown(res.data);
        } else {
          setPoDropDown([])
        }
      })
      .catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setPoDropDown([]);
      });
  };
  const onReset = () => {
    filterForm.resetFields()
    getInvoiceReportData()
  }

  const currentInvoices = useMemo<any[]>(() => {
    const start = (page - 1) * pageSize;
    return data.slice(start, start + pageSize);
  }, [data, page, pageSize]);

  const tableData = useMemo<any[]>(() => {
    const rows: any[] = [];

    currentInvoices.forEach((invoice, invoiceIndex) => {
      const items = invoice.saleOrderItemsDetails && invoice.saleOrderItemsDetails.length > 0 ? invoice.saleOrderItemsDetails : [{}];
      const invoiceRowSpan = items.length;
      const invoiceSerialNo = (page - 1) * pageSize + invoiceIndex + 1;

      items.forEach((item: any, itemIndex: number) => {
        rows.push({
          key: `${invoice.invoiceNumber || 'invoice'}-${invoiceIndex}-${itemIndex}`,
          rowSpan: itemIndex === 0 ? invoiceRowSpan : 0,
          sno: itemIndex === 0 ? invoiceSerialNo : '',
          invoiceDate: invoice.invoiceDate ? moment(invoice.invoiceDate).format('DD-MM-YYYY') : '-',
          invoiceNumber: invoice.invoiceNumber || '-',
          custPoNo: invoice.custPoNo || '-',
          clientName: invoice.clientName || '-',
          endCustomerName: invoice.endCustomerName || '-',
          country: invoice.country || '-',
          destinationName: invoice.destinationName || '-',
          unitName: invoice.unitName || '-',
          totalAmount: invoice.totalAmount ? Number(Number(invoice.totalAmount).toFixed(2)) : '-',
          currency: invoice.currency || '-',
          exchangeRate: invoice.exchangeRate ? Number(Number(invoice.exchangeRate).toFixed(2)) : '-',
          status: invoice.status || '-',
          totalInrAmount: invoice.totalInrAmount ? Number(Number(invoice.totalInrAmount).toFixed(2)) : '-',
          financialYear: invoice.financialYear || '-',
          qCertificateNo: invoice.qCertificateNo || '-',
          packStyle: invoice.packStyle || '-',
          shortCode: item.shortCode || '-',
          item_id: item.item_id || '-',
          netWeight: item.netWeight ? Number(Number(item.netWeight).toFixed(2)) : '-',
          netAmount: item.netAmount ? Number(Number(item.netAmount).toFixed(2)) : '-',
          unitPrice: item.unitPrice ? Number(Number(item.unitPrice).toFixed(2)) : '-',
          invoicedCases: item.invoicedCases ? Number(Number(item.invoicedCases).toFixed(2)) : '-'
        });
      });
    });

    return rows;
  }, [currentInvoices, page, pageSize]);

  const mergedColumn = (dataIndex: string) => ({
    render: (value: any, record: any) => ({
      children: value,
      props: { rowSpan: record.rowSpan },
    }),
    dataIndex,
  });

  const columns: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: 72,
      align: 'center',
      fixed: 'left',
      ...mergedColumn('sno'),
    },
    { title: 'Invoice Date', key: 'invoiceDate', ...mergedColumn('invoiceDate') },
    { title: 'Invoice No', key: 'invoiceNumber', ...mergedColumn('invoiceNumber') },
    { title: 'Cust PO No', key: 'custPoNo', ...mergedColumn('custPoNo') },
    { title: 'Client Name', key: 'clientName', ...mergedColumn('clientName') },
    { title: 'End Customer', key: 'endCustomerName', ...mergedColumn('endCustomerName') },
    { title: 'Country', key: 'country', ...mergedColumn('country') },
    { title: 'Destination', key: 'destinationName', ...mergedColumn('destinationName') },
    { title: 'Currency', key: 'currency', ...mergedColumn('currency') },
    { title: 'Total Amount', key: 'totalAmount', ...mergedColumn('totalAmount') },
    { title: 'Exchange Rate', key: 'exchangeRate', ...mergedColumn('exchangeRate') },
    { title: 'Total INR', key: 'totalInrAmount', ...mergedColumn('totalInrAmount') },
    { title: 'Status', key: 'status', ...mergedColumn('status') },
    { title: 'Financial Year', key: 'financialYear', ...mergedColumn('financialYear') },
    { title: 'Q Cert No', key: 'qCertificateNo', ...mergedColumn('qCertificateNo') },
    { title: 'Pack Style', key: 'packStyle', ...mergedColumn('packStyle') },

    { title: 'Short Code', dataIndex: 'shortCode', key: 'shortCode' },
    { title: 'Net Weight', dataIndex: 'netWeight', key: 'netWeight' },
    { title: 'Unit Price', dataIndex: 'unitPrice', key: 'unitPrice' },
    { title: 'Net Amount', dataIndex: 'netAmount', key: 'netAmount' },
    { title: 'Invoiced Cases', dataIndex: 'invoicedCases', key: 'invoicedCases' },
  ];

  return (
    <Card title={<span style={{ color: 'white' }}>Invoice Info Report</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
      extra={
        <Button type="primary" onClick={handleExportExcel}>Get Excel</Button>
      }
    >
      <Form form={filterForm} layout='vertical'>
        <Row gutter={[16, 16]}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="invoiceDate" label="Invoice Date">
              <DatePicker.RangePicker />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
            <Form.Item name="invoiceNum" label="Invoice Number" >
              <Select
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Invoice Number"


              >
                {invoiceNumber.map(dropData => {
                  return <Option value={dropData.invoiceNumber}>{dropData.invoiceNumber}</Option>
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
           <Form.Item name="poNumber" label="Customer PO Number">
              <Select
                showSearch
                placeholder="Select PO Number"
                optionFilterProp="children"
                allowClear
              >
                {poDropDown.map(inc => (
                  <Option key={inc.PoNumber} value={inc.PoNumber}>
                    {inc.PoNumber}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }} style={{marginTop: 28}}>
            <Form.Item><Button type='primary' onClick={getInvoiceReportData}>Search</Button></Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }} style={{marginTop: 28}}>
            <Form.Item><Button danger onClick={onReset}>Reset</Button></Form.Item>
          </Col>
        </Row>
      </Form>
      <Table
        bordered
        columns={columns}
        dataSource={tableData}
        rowKey={(r) => r.key}
        pagination={false}
        locale={{ emptyText: <Empty description="No invoice information found" /> }}
        scroll={{ x: 'max-content' }}
        summary={() => {
          let totalAmountSum = 0;
          let totalInrAmountSum = 0;
          let netWeightSum = 0;
          let netAmountSum = 0;
          let invoicedCasesSum = 0;

          currentInvoices.forEach(inv => {
            totalAmountSum += Number(inv.totalAmount || 0);
            totalInrAmountSum += Number(inv.totalInrAmount || 0);

            const items = inv.saleOrderItemsDetails && inv.saleOrderItemsDetails.length > 0 ? inv.saleOrderItemsDetails : [];
            items.forEach((item: any) => {
              netWeightSum += Number(item.netWeight || 0);
              netAmountSum += Number(item.netAmount || 0);
              invoicedCasesSum += Number(item.invoicedCases || 0);
            });
          });

          return (
            <Table.Summary.Row style={{ background: '#fafafa', fontWeight: 'bold' }}>
              <Table.Summary.Cell index={0} colSpan={3} align="center">Total</Table.Summary.Cell>
              <Table.Summary.Cell index={1} colSpan={6}></Table.Summary.Cell>
              <Table.Summary.Cell index={1} align='left'>{totalAmountSum ? Number(Number(totalAmountSum).toFixed(2)) : '-'}</Table.Summary.Cell>
              <Table.Summary.Cell index={2}></Table.Summary.Cell>
              <Table.Summary.Cell index={3} align='left'>{totalInrAmountSum ? Number(Number(totalInrAmountSum).toFixed(2)) : '-'}</Table.Summary.Cell>
              <Table.Summary.Cell index={4}></Table.Summary.Cell>
              <Table.Summary.Cell index={5}></Table.Summary.Cell>
              <Table.Summary.Cell index={6}></Table.Summary.Cell>
              <Table.Summary.Cell index={7}></Table.Summary.Cell>
              <Table.Summary.Cell index={8}></Table.Summary.Cell>
              <Table.Summary.Cell index={9} align='left'>{netWeightSum ? Number(Number(netWeightSum).toFixed(2)) : '-'}</Table.Summary.Cell>
              <Table.Summary.Cell index={10}></Table.Summary.Cell>
              <Table.Summary.Cell index={11} align='left'>{netAmountSum ? Number(Number(netAmountSum).toFixed(2)) : '-'}</Table.Summary.Cell>
              <Table.Summary.Cell index={12} align='left'>{invoicedCasesSum ? Number(Number(invoicedCasesSum).toFixed(2)) : '-'}</Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <Pagination
          current={page}
          pageSize={pageSize}
          total={data.length}
          showSizeChanger
          pageSizeOptions={['10', '20', '50', '100']}
          showTotal={(total) => `${total} invoice(s)`}
          onChange={(current, size) => {
            setPage(current);
            if (size && size !== pageSize) setPageSize(size);
          }}
          onShowSizeChange={(_current, size) => {
            setPage(1);
            setPageSize(size);
          }}
        />
      </div>
    </Card>
  );
};

export default InvoiceInfoReport;